import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CustomScroll from "react-custom-scroll";

import ProfileField from "./_ProfileField";
import PasswordRequirements from "./_PasswordRequirements";
import PasswordValidationRulesBuilder from "../../constants/PasswordValidationRulesBuilder";
import { signoutUser } from "../../actions/UserActions";
import { changePassword } from "../../services/Management/UserProfileService";

const cancelPasswordResetPath = "#";
const ProfileChangePassword = (props) => {
  const { setMode, _, User, signoutUser } = props;

  const [fieldValues, setFieldValues] = useState({
    email: User["user-email"],
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [passwordPoliciesLoaded, setPasswordPoliciesLoaded] = useState(false);

  useEffect(() => {
    PasswordValidationRulesBuilder.setPasswordPolicies().then((response) => {
      PasswordValidationRulesBuilder.passwordPolicies = response;
      PasswordValidationRulesBuilder.setValidationRules(
        { ...fieldValues },
        User.userStatus,
        _
      );
      setPasswordPoliciesLoaded(true);
    });
  }, []);

  useEffect(() => {
    PasswordValidationRulesBuilder.setValidationRules(
      { ...fieldValues },
      User.userStatus,
      _
    );
  });

  const passwordResetFields = [
    {
      name: "email",
      label: `${_.EmailAddress} *`,
      type: "email",
      defaultValue: fieldValues.email,
      EditMode: false,
    },
    {
      name: "oldPassword",
      label: `${_.ConfirmOldPassword} *`,
      type: "password",
      defaultValue: fieldValues.oldPassword,
      EditMode: true,
    },
    {
      name: "newPassword",
      label: `${_.EnterNewPassword} *`,
      type: "password",
      defaultValue: fieldValues.newPassword,
      EditMode: true,
    },
    {
      name: "confirmNewPassword",
      label: `${_.ConfirmNewPassword} *`,
      type: "password",
      defaultValue: fieldValues.confirmNewPassword,
      EditMode: true,
    },
  ].map((field) => {
    field.onChange = (e) => {
      PasswordValidationRulesBuilder.setValidationRules(
        { ...fieldValues, [e.target.name]: e.target.value },
        User.userStatus,
        _
      );
      setFieldValues({ ...fieldValues, [e.target.name]: e.target.value });
    };
    return field;
  });

  return (
    <>
      <CustomScroll heightRelativeToParent="100%" allowOuterScroll={true}>
        <h3>
          <i
            className="icon-omni-profile-arrow-left"
            onClick={() => setMode("ViewEdit")}
          />
          {_.ChangePassword}
        </h3>
        <h4>{_.PasswordReset}</h4>
        {passwordResetFields.map((field, key) => (
          <ProfileField {...{ ...field, key }} />
        ))}
        <h4>{_.PasswordMustInclude}:</h4>
        <PasswordRequirements
          passwordValidationRules={
            PasswordValidationRulesBuilder.validationRules
          }
        />
        <div className="change-password-action">
          <button
            className="btn form-control"
            onClick={(e) => {
              e.preventDefault();
              if (
                PasswordValidationRulesBuilder.validationRules
                  .map((r) => r.validation)
                  .reduce((a, c) => a && c, true)
              ) {
                changePassword({
                  oldPassword: fieldValues.oldPassword,
                  newPassword: fieldValues.newPassword,
                  confirmNewPassword: fieldValues.confirmNewPassword,
                }).then(() => {
                  signoutUser();
                });
              }
            }}
            disabled={
              !PasswordValidationRulesBuilder.validationRules
                .map((r) => r.validation)
                .reduce((a, c) => a && c, true)
            }
          >
            {_.Confirm}
          </button>
          <a
            href={cancelPasswordResetPath}
            onClick={(e) => {
              e.preventDefault();
              setMode("ViewEdit");
            }}
          >
            {_.CancelPasswordReset}
          </a>
        </div>
      </CustomScroll>
    </>
  );
};

const mapStateToProps = (state) => state;
const mapActionsToProps = {
  signoutUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(ProfileChangePassword);
